// extracted by mini-css-extract-plugin
export var card = "_se-0";
export var details = "_se-1";